/**
 * UC-11 extension: ActivatePolicyChallenge
 */
import type { PolicyChallenge } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface ActivatePolicyChallengeInput {
  challengeId: string;
}

export interface ActivatePolicyChallengeOutput {
  ok: boolean;
  challenges?: PolicyChallenge[];
  activatedChallenge?: PolicyChallenge;
  error?: string;
}

export interface ActivatePolicyChallengeDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class ActivatePolicyChallengeUseCase {
  constructor(private readonly deps: ActivatePolicyChallengeDependencies) {}

  execute(input: ActivatePolicyChallengeInput): ActivatePolicyChallengeOutput {
    try {
      this.deps.policyManager.activateChallenge(input.challengeId);
      const challenges = this.deps.policyManager.getChallenges();
      const activatedChallenge = challenges.find((c) => c.id === input.challengeId);

      this.deps.logger?.log('debug', 'policy.challenge_activated', {
        challengeId: input.challengeId,
      });

      return { ok: true, challenges, activatedChallenge };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return { ok: false, error: message };
    }
  }
}